export default "__VITE_ASSET__jW722xIb__"